export default {"src":"/_next/static/media/chorizo.9428b72a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};